import { type AlertColor, Box, type ButtonProps, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { Icons } from "@repo/ui";
import { type FC } from "react";
import { type BasicTriggerProps } from ".";
import Attention from "../AttentionBlock";

export interface TriggerButtonProps
	extends BasicTriggerProps,
	Omit<ButtonProps, "children" | "onClick" | "type" | "variant"> {
	variant?:
	| "collapsible"
	| "contained"
	| "outlined"
	| "text"
	| "appBarLink"
	| "contactLink"
	| "clear"
	| "cookie-collapsible"
	| "text-light"
	| "action";
}

const TriggerButton: FC<TriggerButtonProps> = ({
	children,
	onClick,
	variant = "contained",
	...rest
}) => {
	return (
		<Button
			onClick={onClick}
			component="button"
			variant={variant}
			underline="none"
			disableElevation={true}
			{...rest}
		>
			{children}
		</Button>
	);
};
export default TriggerButton;

interface ITriggerButtonWithAttention extends TriggerButtonProps {
	severity: AlertColor;
}

export const TriggerButtonWithAttention: FC<ITriggerButtonWithAttention> = ({
	children,
	startIcon,
	severity = "success",
	sx,
	...rest
}) => {
	return (
		<TriggerButton variant="clear" size="small" sx={sx} {...rest}>
			<Attention icon={startIcon} severity={severity} sx={{ flexGrow: 1 }}>
				<Stack direction="row" alignItems="center">
					<Box sx={{ flexGrow: 1, textAlign: "left" }}>{children}</Box>
					<Icons.CaretRight color={severity} sx={{ width: 7, mr: 3, ml: 5 }} />
				</Stack>
			</Attention>
		</TriggerButton>
	);
};

export const TriggerAttentionButton: FC<TriggerButtonProps> = ({
	children,
	startIcon,
	sx,
	...rest
}) => {
	return (
		<TriggerButton
			{...rest}
			sx={{
				...sx,
				p: 3,
				textAlign: "left",
				".MuiButton-startIcon": {
					width: 40,
					m: 0,
				},
			}}
			variant="clear"
			size="small"
			startIcon={startIcon}
			endIcon={<Icons.CaretRight sx={{ width: 7 }} />}
		>
			<Box component="span" sx={{ flexGrow: 1 }}>
				{children}
			</Box>
		</TriggerButton>
	);
};
